import React from "react";
import costStatus from "../../conf/words";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

class SubCostListComponents extends React.Component {
  constructor(props) {
    super(props)
    const {t} = props
    this.state = {
      tooltipText: <Tooltip id="tooltip">{t('revisedCost')}</Tooltip>,
      attachmentText: <Tooltip id="tooltip">{t('costPhotoExist')}</Tooltip>,
      cancellationRequestText: <Tooltip id="tooltip">{t('awaitingConfirmationForCancellation')}</Tooltip>,
    }
  }

  render() {
    let { subCost, key, t } = this.props;
    if (!subCost.cancellationRequest)
      subCost.cancellationRequest = { now: false };
    return (
      <div className="row">
        <div className="col-md-1">
          {
            subCost.revisions ?
              <OverlayTrigger placement="bottom" overlay={this.state.tooltipText}>
                <i className="fa fa-star star-color" aria-hidden="true"></i>
              </OverlayTrigger>
              : null
          }
          {
            subCost.costPhotos.length > 0
              ?
              <OverlayTrigger placement="bottom" overlay={this.state.attachmentText}>
                <i className="fa fa-paperclip star-color" aria-hidden="true"></i>
              </OverlayTrigger>
              :
              null
          }
          {
            subCost.cancellationRequest.now
              ?
              <OverlayTrigger placement="bottom" overlay={this.state.cancellationRequestText}>
                <i className="fa fa-ban star-color" aria-hidden="true"></i>
              </OverlayTrigger>
              :
              null
          }
        </div>
        <div id="costSubListInvoiceNo" className="col-md-1">
          <h5>{subCost.invoiceNo}</h5>
        </div>
        <div id="costSubListCostType" className="col-md-2">
          <h5>{subCost.costType}</h5>
        </div>
        <div id="costSubListCostDate" className="col-md-2">
          <h5>{subCost.costDate}</h5>
        </div>
        <div id="costSubListCostAmount" className="col-md-1">
          <h5>{subCost.costAmount} {new window.Money(subCost.moneyType).getMoneySymbol()}</h5>
        </div>
        <div id="costSubListCostStatus" className="col-md-2">
          <span className="pending warning-write">{t(costStatus.costStatus[subCost.status])}</span>
        </div>
        <div className="col-md-3">
          {
            subCost.status != "completed"
              ?
              <input type="submit" id="costSubListCostUpdateButton" onClick={() => { this.props.editCost(subCost) }} value={t("edit")} className="btn btn-danger btn-fill btn-wd customBtn" />
              :
              <button type="button" id="costSubListCostUpdateButton" onClick={() => { this.props.editCost(subCost) }} className="btn btn-wd btn-info btn-fill btn-rotate actionBtn">
                <span className="btn-label"><i className="fa fa-info"></i></span>
              </button>
          }
          {subCost.status == "waiting" ? <div style={{ display: "inline-block" }}> &nbsp;
          <button type="button" id="costSubListCostInfoButton" onClick={() => { this.props.costSendToApproval(subCost) }} className="btn btn-primary btn-fill btn-wd actionBtn">
              <span className="btn-label"><i className="fa fa-paper-plane"></i>
              </span>
            </button></div> : null}
          {
            (subCost.status == "manager" || subCost.status == "accounting" || subCost.status == "waiting") && (!subCost.cancellationRequest || !subCost.cancellationRequest.now)
              ?
              <span>
                &nbsp;
              <button type="button" id="costSubListCostDeleteButton" onClick={() => { this.props.deleteCostAction(subCost.costId) }} className="btn btn-wd btn-danger actionBtn"><span className="btn-label"><i className="fa fa-times"></i></span></button>
              </span>
              :
              null
          }
          {
            subCost.transactions
              ?
              <span>
                &nbsp;
              <button type="button" id="costSubListCostTransactionsButton" onClick={() => { this.props.transactionsButton(subCost) }} className="btn btn-wd btn-default actionBtn"><span className="btn-label"><i className="fa fa-cogs"></i></span></button>
              </span>
              :
              null
          }
        </div>
      </div>
    )
  }
}

export default SubCostListComponents;
